import AxiosMockAdapter from 'axios-mock-adapter'
import DemoState from 'components/demo/DemoState'

const base_url = import.meta.env.VITE_API_URL || 'http://localhost:8000/api'

import {
    appVersionResponse, loginResponses, userDataResponses, userBroadcastsResponses, recordsResponses, announcementsResponses, userTimeInStatus, diceGameResponses, featuresResponses, scheduleResponses, userCurrentShiftResponses, otpResponses, breaklistResponses,
    logResponses,
    storeResponses,
    documentsResponses,
    myCompanyResponses,
    myRequestResponses, 
    reportsResponses, 
    timeAdjustmentResponses,
    storeBroadcastResponses,
    trainingMaterialsResponses,
    payslipResponses
} from './mockedResponses'

let collatedRoutes = [
    ...payslipResponses,
    ...trainingMaterialsResponses,
    ...storeBroadcastResponses,
    ...timeAdjustmentResponses,
    ...reportsResponses,
    ...myRequestResponses,
    ...myCompanyResponses,
    ...documentsResponses,
    ...appVersionResponse,
    ...loginResponses,
    ...userDataResponses,
    ...userBroadcastsResponses,
    ...recordsResponses,
    ...announcementsResponses,
    ...userTimeInStatus,
    ...diceGameResponses,
    ...featuresResponses,
    ...scheduleResponses,
    ...userCurrentShiftResponses,
    ...otpResponses,
    ...breaklistResponses,
    ...logResponses,
    ...storeResponses,


]

/// Enables axios request mocking for a given API Sauce instance using the provided routes.
///just an engine for mocking requests no need to modify this code
export default function enableAxiosMocks(apiSauceInstance, routes = collatedRoutes) {
    const demo = DemoState.status()



    if (!apiSauceInstance) {
        console.warn('No API Sauce instance provided to enableAxiosMocks. Axios mocks will not be set up.')
        return null
    }



    const axiosInstance = apiSauceInstance.raw?.axiosInstance || apiSauceInstance.raw?.client || apiSauceInstance.axiosInstance

    const mock = new AxiosMockAdapter(axiosInstance, {
        onNoMatch: 'passthrough',
        delayResponse: 100, // Simulate network delay
    })

    if (!demo.status || !demo) {
        //do nothing here 
        mock.reset()
        return apiSauceInstance
    }

    console.log('will start mocking here')

    // Log axios instance info to help choose the right matcher (path vs full URL)
    try {
        // eslint-disable-next-line no-console
        console.info('[enableAxiosMocks] axios baseURL:', axiosInstance?.defaults?.baseURL)
    } catch (e) {
        // ignore
    }


    //each route has url and ops, where ops is an array of { method, responses }, and responses is an array of { status, data }
    routes.forEach(route => {
        const matcher = `${base_url}/${route.url}`

        const ops = route.ops || []
        if (ops.length === 2) {
            console.log('ops are', ops)
        }

        ops.forEach(op => {
            const method = (op.method || 'get').toLowerCase()
            const responses = op.responses || []
            const onMethod = mock['on' + method.charAt(0).toUpperCase() + method.slice(1)] // onGet, onPost, onPatch

            if (typeof onMethod !== 'function') {
                console.warn('enableAxiosMocks: unsupported mock method', method)
                return
            }

            if (ops.length === 2) {
                console.log('op is ', op)
            }


            responses.forEach(response => {
                const status = response.status || response.code || 200

                console.log(`[enableAxiosMocks] Setting up mock for ${method.toUpperCase()} ${matcher}`)

                //sequences are array of responses in sequence
                const sequences = op.sequences || []
                const condition = response?.condition || null

                if (sequences.length > 0) {
                    console.log(`[enableAxiosMocks] This route has ${sequences.length} responses in sequence.`)
                }

                const onMethod = mock['on' + method.charAt(0).toUpperCase() + method.slice(1)]

                if (typeof onMethod !== 'function') {
                    console.warn('enableAxiosMocks: unsupported mock method', method)
                    return
                }

                const chain = onMethod.call(mock, matcher)


                //if there is condition
                if (ops.length === 2)
                    console.log('condition is', condition)

                chain.reply(config => {
                    console.log(`[enableAxiosMocks] Received request for ${method.toUpperCase()} ${matcher} with request data:`, config.data)

                    console.log('will execute', response.data)
                    const body = typeof config.data === 'string' ? JSON.parse(config.data) : config.data

                    const objectData = typeof response.data === 'function' ? response.data(body) : response.data

                    console.log('generated response data:', objectData)
                    console.log(`[enableAxiosMocks] Generating response for ${method.toUpperCase()} ${matcher} with status ${status} and data:`, objectData)

                    return [status, objectData]
                })

            })



        })

    })


    // Allow other unmocked requests to pass through
    if (typeof mock.onAny === 'function' && typeof mock.onAny().passThrough === 'function') {
        mock.onAny().passThrough()
    }

    return mock
}
